module.exports = __webpack_public_path__ + "static/media/user-plus-solid.a5d58870.svg";